import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import API from "../api";

export default function AddLead() {
  const [form, setForm] = useState({
    title: "",
    sector: "",
    stage: "",
    co2Reduction: "",
    contactInfo: {},
    companyInfo: {},
    projectInfo: {},
    comments: ""
  });

  const update = (key, value) => setForm({ ...form, [key]: value });

  const updateNested = (section, key, value) => {
    setForm({
      ...form,
      [section]: { ...form[section], [key]: value }
    });
  };

  const submit = async () => {
    await API.post("/leads", form);
    alert("Lead Created Successfully");
  };

  return (
    <div className="flex">
      <Sidebar />
      <div className="flex-1 bg-gray-50 min-h-screen">
        <Navbar />

        <div className="max-w-5xl mx-auto p-6 space-y-6">

          <h1 className="text-2xl font-bold">Create New Lead</h1>

          {/* BASIC */}
          <Card title="Basic Information">
            <Input placeholder="Project Title" onChange={e => update("title", e.target.value)} />

            <div className="grid grid-cols-2 gap-4">
              <Select label="Sector" onChange={e => update("sector", e.target.value)}
                options={["Green Hydrogen","Green Buildings","Sustainable Agriculture"]} />

              <Input placeholder="Stage (Pilot / Scale)" onChange={e => update("stage", e.target.value)} />
            </div>

            <Input placeholder="CO₂ Reduction (e.g. 25,000 tCO₂/yr)"
              onChange={e => update("co2Reduction", e.target.value)} />
          </Card>

          {/* CONTACT */}
          <Card title="Contact Information">
            <Grid>
              <Input placeholder="Full Name" onChange={e => updateNested("contactInfo","name",e.target.value)} />
              <Input placeholder="Email" onChange={e => updateNested("contactInfo","email",e.target.value)} />
              <Input placeholder="Phone" onChange={e => updateNested("contactInfo","phone",e.target.value)} />
            </Grid>
          </Card>

          {/* COMPANY */}
          <Card title="Company Information">
            <Grid>
              <Select label="Area of Interest"
                onChange={e => updateNested("companyInfo","interest",e.target.value)}
                options={[
                  "Renewable Energy & Storage",
                  "Green Mobility & EV",
                  "Green Hydrogen",
                  "AI in Energy",
                  "Sustainable Agriculture"
                ]}
              />

              <Select label="Company Age"
                onChange={e => updateNested("companyInfo","companyAge",e.target.value)}
                options={["Below 1 year","1-3 years","3-5 years","5+ years"]}
              />

              <Select label="Revenue"
                onChange={e => updateNested("companyInfo","revenue",e.target.value)}
                options={["<200k","200k-500k","500k-1M",">1M"]}
              />

              <Select label="EBITDA"
                onChange={e => updateNested("companyInfo","ebitda",e.target.value)}
                options={["Yes","No","Not Sure"]}
              />
            </Grid>
          </Card>

          {/* PROJECT */}
          <Card title="Project Information">
            <Grid>
              <Select label="Why Join"
                onChange={e => updateNested("projectInfo","reason",e.target.value)}
                options={[
                  "Global expansion",
                  "Funding & IPO",
                  "Only Funding",
                  "All of the above"
                ]}
              />

              <Select label="Biggest Project Size"
                onChange={e => updateNested("projectInfo","biggestProjectSize",e.target.value)}
                options={["25k-100k","100k-500k","500k-1M","1M-3M",">3M"]}
              />

              <Select label="Project Completion"
                onChange={e => updateNested("projectInfo","projectFinishedWhen",e.target.value)}
                options={["1 year ago","6 months ago","3 months ago","Under construction"]}
              />

              <Select label="Funding Source"
                onChange={e => updateNested("projectInfo","fundingSource",e.target.value)}
                options={["Equity","Bank Loan","Mixed","Other"]}
              />
            </Grid>

            <Input placeholder="If Other funding source"
              onChange={e => updateNested("projectInfo","fundingSourceOther",e.target.value)} />
          </Card>

          {/* COMMENTS */}
          <Card title="Comments">
            <textarea
              className="w-full border p-3 rounded"
              rows="4"
              placeholder="Describe your proposal..."
              onChange={e => update("comments", e.target.value)}
            />
          </Card>

          <button
            onClick={submit}
            className="bg-green-600 text-white px-6 py-3 rounded-lg shadow hover:bg-green-700"
          >
            Submit Lead
          </button>

        </div>
      </div>
    </div>
  );
}

/* ---------- UI COMPONENTS ---------- */

function Card({ title, children }) {
  return (
    <div className="bg-white p-5 rounded-xl shadow">
      <h2 className="font-semibold mb-4 text-lg">{title}</h2>
      <div className="space-y-3">{children}</div>
    </div>
  );
}

function Input({ placeholder, ...props }) {
  return (
    <input
      className="w-full border p-3 rounded focus:ring-2 focus:ring-green-400"
      placeholder={placeholder}
      {...props}
    />
  );
}

function Select({ label, options, ...props }) {
  return (
    <select className="w-full border p-3 rounded" {...props}>
      <option>{label}</option>
      {options.map((o, i) => <option key={i}>{o}</option>)}
    </select>
  );
}

function Grid({ children }) {
  return <div className="grid grid-cols-2 gap-4">{children}</div>;
}